












































































































































































































import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import CrudStepsNavBar from '@/reusable/Mantenedor/CrudStepsNavBar.vue';
import { PasosCrud } from '@/reusable/Mantenedor/mantenedorUtils';
import ContenidoModal from '@/reusable/Modal/ContenidoModal.vue';
import { ServicioProxy } from '@/config/enums';
import { AxiosVue } from '@/AxiosVue';
import { fetchReportesSerie } from './fetchReporteSerie';
import moment from 'moment';
import TextField from '@/reusable/Form/TextField.vue';
import { actionsEvent } from '@/setup';
import { Funcionalidades } from '@/config/funcionalidades';
import config from '@/config/index';
import VerEditarModalInet from './verEditarModalInet.vue';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  ICellRendererParams,
  RowNode,
} from 'ag-grid-community';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import { EstadoGrillaVm } from '@/interfaces/EstadoGrillaVm';
import Confirmation from '@/components/Confirmation.vue';

@Component({
  components: {
    CabeceraModal,
    ModalMantenedor,
    CrudStepsNavBar,
    ContenidoModal,
    TextField,
    FormFieldsContainer,
    MantenedorGridSinCodigo,
    MantenedorGrid,
    VerEditarModalInet,
    'app-confirmacion': Confirmation,
  },
})
export default class VerEditarModal extends Vue {
  @Prop({ default: true }) show: boolean;
  @Prop({ default: null }) codigoEquipo: any;
  ocultar: boolean = false;
  id_equipo: any;
  respuesta: any;
  dictionaryFormErrors: any = {};
  plataformas: any = [];
  plataforma: any = null;
  tipoeqcuenta_inet_new: any = null;
  gridOptions: GridOptions;
  gridApi: GridApi;
  columnApi: ColumnApi;
  mostrarConfirmacionEliminar: boolean = false;
  columnDefs: Array<ColDef> = [];
  estadoGrillaVm: EstadoGrillaVm;
  dialog2: boolean = false;
  serverSide: any;
  newaccounts: any = [];
  optionslist: any = [
    { text: 'EQUIPO', value: false },
    { text: 'PERIFÉRICO', value: true },
  ];

  optionslist_2: any = [
    { text: 'ACTIVO', value: false },
    { text: 'INACTIVO', value: true },
  ];

  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();

  pasoActivoIndex = 1;
  readonly pasos: PasosCrud = {
    requerimiento: {
      accion: 'Editar Equipo',
      visible: true,
      step: 1,
      title: 'Editar Equipo',
      icon: 'ballot',
      formState: {
        entity: null,
        validator: null,
        isDirty: false,
      },
    },
  };

  readonly funcionalidad: Funcionalidades =
    Funcionalidades.tiposEquiposGrillaCodigos;
  cambioEstado: boolean;
  estadoSelect: boolean;
  estadoInicial: boolean;

  async editar() {
    this.cambioEstado = false;
    this.respuesta = await this.$validator.validateAll();
    let self = this;
    this.loadingService.showLoading();
    return fetchReportesSerie(
      {
        usuarioid_alta: JSON.parse(localStorage.getItem('user')).id,
        usuariorut_alta: JSON.parse(localStorage.getItem('user'))
          .rutClienteDefecto,
        tipoeqid: this.id_equipo,
        tipoeqname: this.formFields.nombreEquipo.value.toString().toUpperCase(),
        tipoeqname_crm: this.formFields.nombreCRM.value
          .toString()
          .toUpperCase(),
        tipoeqname_inet: this.formFields.nombreINET.value
          .toString()
          .toUpperCase(),
        tipoeqcodigo: this.formFields.tipoeqcodigo.value
          .toString()
          .toUpperCase(),
        tipoeqperiferico: this.formFields.clase.value,
        tipoeqestado: this.formFields.estado.value,
        tipoeqseriado: this.formFields.seriado.value,
        tipoeqid_r: this.formFields.tipoeqid_r.value || 'null',
        tipoeqcuenta_inet: this.formFields.tipoeqcuenta_inet.value,
      },
      'conecta_matriz_producto/editar_equipo'
    )
      .then(async (data: any) => {
        if (this.respuesta == false) {
          self.$snotify.error('EL formulario presenta errores.', {
            timeout: 3000,
          });
          return;
        }
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.newaccounts.forEach(
            async (serie: { tipoeqcuenta_inet: any; plataformaid: any }) => {
              // Llamar a insertar_cuentasInet para cada elemento
              await this.insertar_cuentasInet(
                serie.tipoeqcuenta_inet,
                serie.plataformaid,
                this.codigoEquipo.tipoeqid
              );
            }
          );
          self.$snotify.success(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.handleCerrar();
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  formFields: FormFieldDefMap = {
    tipoeqcodigo: {
      label: 'Código de Equipo',
      id: '',
      value: '',
    },
    nombreEquipo: {
      label: 'Nombre del Equipo',
      id: '',
      value: '',
    },
    nombreCRM: {
      label: 'Nombre en CRM',
      id: '',
      value: '',
    },
    nombreINET: {
      label: 'Nombre Existencia INET',
      id: '',
      value: '',
    },
    clase: {
      label: 'Clase',
      id: '',
      value: '',
    },
    fechaCrea: {
      label: 'Fecha de Creación',
      id: '',
      value: moment().format('YYYY-MM-DD h:mm:ss'),
    },
    usuarioCrea: {
      label: 'Usuario Creador',
      id: '',
      value: '',
    },
    fechaModifica: {
      label: 'Fecha de Modificación',
      id: '',
      value: moment().format('YYYY-MM-DD h:mm:ss'),
    },
    usuarioModifica: {
      label: 'Usuario Modificador',
      id: '',
      value: '',
    },
    estado: {
      label: 'Estado',
      id: '',
      value: null,
    },
    seriado: {
      label: 'Seguimiento Seriado',
      id: 'Seriado',
      value: true,
    },
    tipoeqid_r: {
      label: 'Tipo Usado Asociado',
      id: 'tipoeqid_r',
      value: '',
    },
    tipoeqcuenta_inet: {
      label: 'Cuenta existencias INET',
      id: 'tipoeqcuenta_inet',
      value: '',
    },
  };
  equipos_totales: any = [];
  async getEquipos() {
    let self = this;
    this.loadingService.showLoading();
    return fetchReportesSerie(
      {
        id: JSON.parse(localStorage.getItem('user')).id,
        equipoId: this.id_equipo,
      },
      'conecta_matriz_producto/s_crear_equipo'
    )
      .then(async (data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.formFields.usuarioModifica.value = data.data.usuariocreador.LISTA[0].concat_ws.toUpperCase();
          this.equipos_totales = data.data.total_equipos.LISTA;
          this.plataformas = data.data.plataformas.LISTA;
          await this.getCuentasInet();
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  async getCuentasInet() {
    let self = this;
    this.loadingService.showLoading();

    try {
      const data = await fetchReportesSerie(
        {
          tipoeqid: this.id_equipo,
        },
        'conecta_matriz_producto/consultar_cuentaInet'
      );

      if (
        data.data.CODIGO_RESPUESTA === '1' &&
        data.data.cuentasInet &&
        data.data.cuentasInet.LISTA &&
        data.data.cuentasInet.LISTA.every(
          (serie: any) =>
            'tipoeq_cuentas_id' in serie &&
            'tipoeqid' in serie &&
            'plataformaid' in serie &&
            'tipoeqcuenta_inet' in serie
        )
      ) {
        const nuevasSeries = data.data.cuentasInet.LISTA.map(
          (serie: { plataformaid: any; plataformaNombre: any }) => {
            const plataformaId = serie.plataformaid;
            const plataformaConfig = this.plataformas.find(
              (config: { configid: any }) => config.configid === plataformaId
            );

            serie.plataformaNombre = plataformaConfig
              ? plataformaConfig.configvalor
              : null;
            return serie;
          }
        );

        this.loadedSeries = nuevasSeries;
        this.gridApi.setRowData(this.loadedSeries);
      } else {
        self.$snotify.warning(' Equipo sin cuentas de facturación INET', {
          timeout: 3000,
        });
        this.loadedSeries = [];
      }
    } catch (error) {
      self.$snotify.error('Ocurrió un error', { timeout: 3000 });
    } finally {
      this.loadingService.hideLoading();
    }
  }

  mounted() {
    this.formFields.tipoeqcodigo.value = this.codigoEquipo.tipoeqcodigo;
    this.formFields.tipoeqid_r.value = this.codigoEquipo.tipoeqid_r;
    this.formFields.nombreEquipo.value = this.codigoEquipo.tipoeqname;
    this.formFields.nombreCRM.value = this.codigoEquipo.tipoeqname_crm;
    this.formFields.nombreINET.value = this.codigoEquipo.tipoeqname_inet;
    this.formFields.tipoeqcuenta_inet.value = this.codigoEquipo.tipoeqcuenta_inet;
    this.formFields.seriado.value = this.codigoEquipo.tipoeqseriado == 'SI';
    this.id_equipo = this.codigoEquipo.tipoeqid;
    if (this.codigoEquipo.tipoeqperiferico == 't') {
      this.formFields.clase.value = this.optionslist[1];
    } else {
      this.formFields.clase.value = this.optionslist[0];
    }
    if (this.codigoEquipo.tipoeqbaja == 'f') {
      this.formFields.estado.value = {
        text: 'ACTIVO',
        value: false,
      };
    } else {
      (this.ocultar = true),
        (this.formFields.estado.value = {
          text: 'INACTIVO',
          value: true,
        });
    }
    this.getEquipos();
    this.dictionaryFormErrors = {
      custom: {
        rut: {
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
          regex: () => config.errorMensajes.regex,
        },
        name: {
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
          alpha_spaces: () =>
            '* El campo Nombre solo debe contener letras y/o espacios.',
        },
        ubicacion: {
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
        },
        apellidoPaterno: {
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
          alpha_spaces: () =>
            '* El campo Apellido Paterno solo debe contener letras y/o espacios.',
        },
        apellidoMaterno: {
          max: () => config.errorMensajes.maxLength,
          alpha_spaces: () =>
            '* El campo Apellido Materno solo debe contener letras y/o espacios.',
        },
        email: {
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
        },
        contrasena: {
          required: () => config.errorMensajes.textoRequerido,
          confirmed: () => config.errorMensajes.passNoIguales,
          min: () => 'El campo debe tener al menos 8 caracteres.',
        },
        direccion: {
          max: () => config.errorMensajes.maxLength,
        },
        telefonoFijo: {
          max: () => config.errorMensajes.maxLength,
          numeric: () => 'El campo debe ser unicamente numérico',
        },
        celular: {
          max: () => config.errorMensajes.maxLength,
          regex: () => config.errorMensajes.regex,
        },
        estado: {
          required: () => config.errorMensajes.textoRequerido,
        },
        fechaNacimiento: {
          mayorDeEdad: () => config.errorMensajes.fechaMayoriaEdad,
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
        },
      },
    };
    this.$validator.localize('es', this.dictionaryFormErrors);
  }
  @Watch('ReporteSeleccionado')
  handleRutasSeleccionadas() {
    return;
  }

  handleCerrar() {
    this.$emit('cerrarCrear');
  }
  addDevice() {
    if (!this.tipoeqcuenta_inet_new || !this.plataforma) {
      this.$snotify.error('Por favor agregue todos los campos');
      return;
    }
    let plataform = this.plataforma;
    let selected = this.plataformas.find((eq: any) => {
      return eq.configid == plataform;
    }).configvalor;
    let newDevice = {
      tipoeqcuenta_inet: this.tipoeqcuenta_inet_new,
      plataformaNombre: selected,
      plataformaid: this.plataforma,
    };
    const isDuplicate = this.loadedSeries.some(
      serie => serie.plataformaid === newDevice.plataformaid
    );

    if (isDuplicate) {
      this.$snotify.error('Esta plataforma ya fue ingresada para este Equipo', {
        timeout: 3000,
      });
      this.tipoeqcuenta_inet_new = null;
      this.plataforma = null;
    } else {
      this.loadedSeries.push(newDevice);
      this.newaccounts.push(newDevice);
      this.clearDevices();
      this.reloadEquipos();
      this.updateFlete();
    }
  }

  clearDevices() {
    this.plataforma = null;
    this.tipoeqcuenta_inet_new = null;
  }

  newList: Array<any> = [];
  alreadyReload: boolean = false;

  reloadEquipos() {
    if (this.loadedSeries.length > 0) {
      this.newList = this.plataformas.filter(
        (eq: any) =>
          !this.loadedSeries.some(serie => serie.configid === eq.configid)
      );
      this.alreadyReload = true;
      return this.newList;
    }
  }

  constructor() {
    super();
    actionsEvent.onEditar(this.handleEditarClick);
    actionsEvent.onEliminar(this.handleDelete);
    let self = this;
    this.columnDefs = [
      {
        headerName: 'Cuenta INET',
        field: 'tipoeqcuenta_inet',
        resizable: true,
        sortable: true,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Plataforma',
        field: 'plataformaNombre',
        resizable: true,
        sortable: true,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
      },
    ];

    this.gridOptions = {
      pagination: true,
      paginationPageSize: 6, //Solución Paginación
      //cacheBlockSize: 50, //Solución Paginación
      //paginationAutoPageSize: false,
      rowModelType: 'normal',
      columnDefs: this.columnDefs,
      //rowModelType: 'serverSide',
      serverSideDatasource: this.serverSide,
      rowSelection: 'single',
      columnTypes: {},
      suppressCsvExport: true,
      suppressExcelExport: true,
      onGridReady: this.handleGridReady,
      onModelUpdated: this.onModelUpdated,
      onSelectionChanged: this.onSelectionChanged,
      processCellForClipboard: ({ value }) => {},
      onGridSizeChanged: event => {
        //event.api.sizeColumnsToFit();
      },
    };
  }
  async handleGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;
    this.columnApi = event.columnApi;
    this.gridApi.setRowData([]);
    this.gridApi.setDomLayout('autoHeight');
  }
  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
  }

  handleEditarClick(params: ICellRendererParams) {
    this.codigoEquipo = params.data;
    this.dialog2 = true;
  }
  data: any = [];
  handleDelete(event: any) {
    this.data = event.data;
    this.mostrarConfirmacionEliminar = true;

    this.plataformaNombre = this.data.plataformaNombre;
    this.cuentaInetPlataforma = this.data.tipoeqcuenta_inet;
  }
  plataformaNombre: any = '';
  cuentaInetPlataforma: any = '';

  handleDeleteCoor(event: any) {
    this.mostrarConfirmacionEliminar = false;
    if (event) {
      this.deletecuentaInet(this.data);
    }
  }
  onSelectionChanged(params: any) {}
  loadedSeries: Array<any> = [];
  updateFlete() {
    if (this.loadedSeries.length > 0) {
      this.loadedSeries = this.loadedSeries
        .map((e: any) => {
          return {
            ...e,
            tipoeqcuenta_inet: e.tipoeqcuenta_inet,
            plataformaNombre: e.plataformaNombre,
            plataformaid: e.plataformaid,
          };
        })
        .filter((serie, index, self) => {
          const isUnique =
            index ===
            self.findIndex(s => s.plataformaid === serie.plataformaid);

          // Mostrar notificación de error si no es única

          return isUnique;
        });
      this.gridApi.setRowData(this.loadedSeries);
    }
  }

  async handleCierreModalCrear() {
    this.dialog2 = false;
  }

  async insertar_cuentasInet(
    cuentaInet: any,
    plataformaid: any,
    nuevo_tipoeqid: any
  ) {
    let self = this;
    this.loadingService.showLoading();

    return fetchReportesSerie(
      {
        cuentaInet,
        plataformaid,
        nuevo_tipoeqid,
      },
      'conecta_matriz_producto/insertar_cuentaInet'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA != '1') {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  async deletecuentaInet(params: any) {
    let self = this;
    this.loadingService.showLoading();
    return fetchReportesSerie(
      {
        tipoeq_cuentas_id: params.tipoeq_cuentas_id,
        plataformaNombre: params.plataformaNombre,
        cuentaInet: params.tipoeqcuenta_inet,
      },
      'conecta_matriz_producto/delete_cuentaInet'
    )
      .then(async (data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.$snotify.success(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.loadedSeries = [];
          await this.getCuentasInet();
          this.gridApi.setRowData(this.loadedSeries);
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.gridApi.setRowData((this.loadedSeries = []));
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(async () => {
        this.loadingService.hideLoading();
      });
  }
}
